export default "__VITE_ASSET__ae3decef__"